module.exports = __webpack_public_path__ + "img/ic_mpe_headsock_press.269ab81c.png";